import { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { Colors } from "../../../constants/styles";
import { Loader, SearchBar } from "../../../components";
import { postRequest } from "../../../constants/api";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Alert,
  Button,
  Snackbar,
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Autocomplete,
  TextField,
  Paper,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import DatePicker from "react-datepicker";
import { makeStyles } from "@mui/styles";
import SaveIcon from "@mui/icons-material/Save";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { NumericFormat } from "react-number-format";
import useScreenWidth from "../../../hooks/useScreenWidth";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

const TambahKelompok = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [noKelompok, setNoKelompok] = useState("");
  const [tglKelompok, setTglKelompok] = useState(new Date());
  const [patokanHarga, setPatokanHarga] = useState("");
  const [angsuran, setAngsuran] = useState("");
  const [totalAngsuran, setTotalAngsuran] = useState("");
  const [jangkaWaktu, setJangkaWaktu] = useState("");
  const [administrasi, setAdministrasi] = useState("");
  const [patokanBayangan, setPatokanBayangan] = useState("");
  const [keterangan, setKeterangan] = useState("");

  // Program Arisan
  const [program1, setProgram1] = useState(false);
  const [program2, setProgram2] = useState(false);
  const [program3, setProgram3] = useState(false);
  const [program4, setProgram4] = useState(false);
  const [program5, setProgram5] = useState(false);

  // Data Peserta Kelompok
  const [reloadListPesertaKelompok, setReloadListPesertaKelompok] = useState(0);
  const [listPesertaKelompok, setListPesertaKelompok] = useState([
    {
      namaPeserta: "",
      jenisJaminan: "",
      nomorJaminan: "",
      nilaiJaminan: "",
      keterangan: "",
    },
  ]);

  const [pesertasData, setPesertasData] = useState([]);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const classes = useStyles();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  let pesertaOptions = pesertasData.map((peserta) => ({
    label: `${peserta.namaPeserta}`,
  }));
  let jenisJaminanOptions = [
    {
      label: "SERTIFIKAT",
    },
    {
      label: "BPKB",
    },
  ];

  useEffect(() => {
    getPesertasData();
    getNextKodeKelompok();
  }, []);

  const getPesertasData = async () => {
    setLoading(true);
    const allPesertas = await postRequest(`/pesertas`, {}, navigate, dispatch);
    setPesertasData(allPesertas.data);
    setLoading(false);
  };

  const getNextKodeKelompok = async () => {
    setLoading(true);
    const nextKodeKelompok = await postRequest(
      `/kelompoksNextKode`,
      {},
      navigate,
      dispatch,
    );
    setNoKelompok(nextKodeKelompok.data);
    setLoading(false);
  };

  const saveKelompok = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      try {
        setLoading(true);
        await postRequest(
          `/saveKelompok`,
          {
            tglKelompok,
            patokanHarga,
            angsuran,
            totalAngsuran,
            jangkaWaktu,
            administrasi,
            patokanBayangan,
            keterangan,

            listPesertaKelompok,
          },
          navigate,
          dispatch,
        );
        setLoading(false);
        navigate("/daftarKelompok");
      } catch (error) {
        alert(error.response.data.message);
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Arisan</h3>
      <h5 style={{ fontWeight: 400 }}>Tambah Kelompok</h5>
      <hr />
      <Form noValidate validated={validated} onSubmit={saveKelompok}>
        <Card>
          <Card.Header>Kelompok</Card.Header>
          <Card.Body>
            <Box sx={showDataContainer}>
              <Box sx={showDataWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Kelompok :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={noKelompok}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tanggal <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <DatePicker
                          required
                          dateFormat="dd/MM/yyyy"
                          selected={tglKelompok}
                          customInput={<Form.Control required />}
                          onChange={(date) => setTglKelompok(date)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Patokan Harga <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={patokanHarga}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setPatokanHarga(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Angsuran <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={angsuran}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            let tempNumber = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");

                            setAngsuran(tempNumber);

                            let tempTotalAngsuran =
                              parseInt(tempNumber) * parseInt(jangkaWaktu);
                            setTotalAngsuran(tempTotalAngsuran);
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Jangka Waktu <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={jangkaWaktu}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            let tempNumber = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");

                            setJangkaWaktu(tempNumber);

                            let tempTotalAngsuran =
                              parseInt(angsuran) * parseInt(tempNumber);
                            setTotalAngsuran(tempTotalAngsuran);
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Total Angsuran <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={totalAngsuran}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setTotalAngsuran(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, ""),
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Administrasi (%) <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          type="number"
                          value={administrasi}
                          onChange={(e) => setAdministrasi(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Patokan Bayangan (%) <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          type="number"
                          value={patokanBayangan}
                          onChange={(e) => setPatokanBayangan(e.target.value)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Keterangan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={keterangan}
                          onChange={(e) => {
                            setKeterangan(e.target.value);
                          }}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[showDataWrapper, secondWrapper]}>
                <Typography variant="p">Program</Typography>
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox checked={program1} />}
                    label="4 Miliar, Setoran 100 juta"
                    onChange={() => {
                      setProgram1(!program1);
                      setProgram2(false);
                      setProgram3(false);
                      setProgram4(false);
                      setProgram5(false);

                      let tempPatokanHarga = 4000000000;
                      setPatokanHarga(tempPatokanHarga);

                      let tempAngsuran = 100000000;
                      setAngsuran(tempAngsuran);

                      let tempJangkaWaktu = 36;
                      setJangkaWaktu(tempJangkaWaktu);

                      let tempTotalAngsuran =
                        parseInt(tempAngsuran) * parseInt(tempJangkaWaktu);
                      setTotalAngsuran(tempTotalAngsuran);

                      setAdministrasi(4.25);
                      setPatokanBayangan(10);
                    }}
                  />
                </FormGroup>
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox checked={program2} />}
                    label="2 Miliar, Setoran 50 juta"
                    onChange={() => {
                      setProgram1(false);
                      setProgram2(!program2);
                      setProgram3(false);
                      setProgram4(false);
                      setProgram5(false);

                      let tempPatokanHarga = 2000000000;
                      setPatokanHarga(tempPatokanHarga);

                      let tempAngsuran = 50000000;
                      setAngsuran(tempAngsuran);

                      let tempJangkaWaktu = 36;
                      setJangkaWaktu(tempJangkaWaktu);

                      let tempTotalAngsuran =
                        parseInt(tempAngsuran) * parseInt(tempJangkaWaktu);
                      setTotalAngsuran(tempTotalAngsuran);

                      setAdministrasi(4.25);
                      setPatokanBayangan(10);
                    }}
                  />
                </FormGroup>
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox checked={program3} />}
                    label="1 Miliar, Setoran 25 juta"
                    onChange={() => {
                      setProgram1(false);
                      setProgram2(false);
                      setProgram3(!program3);
                      setProgram4(false);
                      setProgram5(false);

                      let tempPatokanHarga = 1000000000;
                      setPatokanHarga(tempPatokanHarga);

                      let tempAngsuran = 25000000;
                      setAngsuran(tempAngsuran);

                      let tempJangkaWaktu = 36;
                      setJangkaWaktu(tempJangkaWaktu);

                      let tempTotalAngsuran =
                        parseInt(tempAngsuran) * parseInt(tempJangkaWaktu);
                      setTotalAngsuran(tempTotalAngsuran);

                      setAdministrasi(4.25);
                      setPatokanBayangan(10);
                    }}
                  />
                </FormGroup>
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox checked={program4} />}
                    label="400 Juta, Setoran 10 juta"
                    onChange={() => {
                      setProgram1(false);
                      setProgram2(false);
                      setProgram3(false);
                      setProgram4(!program4);
                      setProgram5(false);

                      let tempPatokanHarga = 400000000;
                      setPatokanHarga(tempPatokanHarga);

                      let tempAngsuran = 10000000;
                      setAngsuran(tempAngsuran);

                      let tempJangkaWaktu = 36;
                      setJangkaWaktu(tempJangkaWaktu);

                      let tempTotalAngsuran =
                        parseInt(tempAngsuran) * parseInt(tempJangkaWaktu);
                      setTotalAngsuran(tempTotalAngsuran);

                      setAdministrasi(4.25);
                      setPatokanBayangan(10);
                    }}
                  />
                </FormGroup>
                <FormGroup>
                  <FormControlLabel
                    control={<Checkbox checked={program5} />}
                    label="200 Juta, Setoran 5 juta"
                    onChange={() => {
                      setProgram1(false);
                      setProgram2(false);
                      setProgram3(false);
                      setProgram4(false);
                      setProgram5(!program5);

                      let tempPatokanHarga = 200000000;
                      setPatokanHarga(tempPatokanHarga);

                      let tempAngsuran = 5000000;
                      setAngsuran(tempAngsuran);

                      let tempJangkaWaktu = 36;
                      setJangkaWaktu(tempJangkaWaktu);

                      let tempTotalAngsuran =
                        parseInt(tempAngsuran) * parseInt(tempJangkaWaktu);
                      setTotalAngsuran(tempTotalAngsuran);

                      setAdministrasi(4.25);
                      setPatokanBayangan(10);
                    }}
                  />
                </FormGroup>
              </Box>
            </Box>
          </Card.Body>
        </Card>
        <Card style={{ marginTop: 10 }}>
          <Card.Header>Peserta Kelompok</Card.Header>
          <Card.Body>
            <Box sx={spacingTop}>
              <Button
                variant="contained"
                color="info"
                sx={{
                  bgcolor: "info.light",
                  textTransform: "none",
                  marginRight: 2,
                  marginBottom: 2,
                }}
                onClick={() => {
                  listPesertaKelompok.push({
                    keterangan: "",
                    jumlah: "",
                  });
                  setReloadListPesertaKelompok(
                    Math.floor(Math.random() * 1000),
                  );
                }}
              >
                {"+ Input Peserta Kelompok"}
              </Button>
            </Box>
            <TableContainer component={Paper} sx={{ width: "100%" }}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      No.
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Nama Peserta
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Jenis Jaminan
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Nomor Jaminan
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Nilai Jaminan
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Keterangan
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Hapus
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listPesertaKelompok.map((pesertaKelompok, index) => (
                    <TableRow>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>
                        <Autocomplete
                          freeSolo
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={pesertaOptions}
                          renderInput={(params) => (
                            <TextField
                              size="small"
                              sx={{
                                width: "200px",
                                "& .MuiInputBase-input": {
                                  textTransform: "uppercase",
                                },
                              }}
                              {...params}
                            />
                          )}
                          value={pesertaKelompok.namaPeserta}
                          onInputChange={(e, value) => {
                            pesertaKelompok.namaPeserta = value;
                            setReloadListPesertaKelompok(
                              Math.floor(Math.random() * 1000),
                            );
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={jenisJaminanOptions}
                          renderInput={(params) => (
                            <TextField
                              size="small"
                              sx={{ width: "150px" }}
                              {...params}
                            />
                          )}
                          value={pesertaKelompok.jenisJaminan}
                          onChange={(e, value) => {
                            if (value) {
                              pesertaKelompok.jenisJaminan = value.label;
                              setReloadListPesertaKelompok(
                                Math.floor(Math.random() * 1000),
                              );
                            } else {
                              pesertaKelompok.jenisJaminan = "";
                              setReloadListPesertaKelompok(
                                Math.floor(Math.random() * 1000),
                              );
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Form.Control
                          as="textarea"
                          rows={2}
                          value={pesertaKelompok.nomorJaminan}
                          onChange={(e) => {
                            pesertaKelompok.nomorJaminan =
                              e.target.value.toUpperCase();
                            setReloadListPesertaKelompok(
                              Math.floor(Math.random() * 1000),
                            );
                          }}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <NumericFormat
                          value={pesertaKelompok.nilaiJaminan}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            pesertaKelompok.nilaiJaminan = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");

                            setReloadListPesertaKelompok(
                              Math.floor(Math.random() * 1000),
                            );
                          }}
                        />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Form.Control
                          as="textarea"
                          rows={2}
                          value={pesertaKelompok.keterangan}
                          onChange={(e) => {
                            pesertaKelompok.keterangan =
                              e.target.value.toUpperCase();
                            setReloadListPesertaKelompok(
                              Math.floor(Math.random() * 1000),
                            );
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="error"
                          sx={{ textTransform: "none" }}
                          onClick={() => {
                            listPesertaKelompok.splice(index, 1);

                            setReloadListPesertaKelompok(
                              Math.floor(Math.random() * 1000),
                            );
                          }}
                        >
                          <DeleteOutlineIcon />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card.Body>
        </Card>
        <Box sx={spacingTop}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => navigate("/daftarKelompok")}
            sx={{ marginRight: 2 }}
          >
            {"< Kembali"}
          </Button>
          <Button variant="contained" startIcon={<SaveIcon />} type="submit">
            Simpan
          </Button>
        </Box>
      </Form>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default TambahKelompok;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const subTitleText = {
  fontWeight: "900",
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "800px",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};

const colorRed = {
  color: "red",
};

const showDataContainer = {
  mt: 4,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};
